<div class="sidebar" *ngIf="userMenu.length">
  <ul class="nav-links">
    <ng-container *ngFor="let item of userMenu">
      <li *ngIf="item.menuPage==null" class="subMenu_header" [ngClass]="{'showMenu': item.isExpanded}" (click)="toggleMenu(item, userMenu,$event)">
        <div class="header_link">
          <a class="w-100">
            <div class="w-100 d-flex align-items-center justify-content-between">
              <p class="header_name">{{ item.menuName }}</p>
              <i class="ri-arrow-down-s-line arrow" *ngIf="item.childItems.length"></i>
            </div>
            
            
          </a>
        </div>
        <ng-container *ngIf="item.isExpanded">
          <ng-container *ngFor="let child of item.childItems">
            <ng-container *ngTemplateOutlet="renderMenuItem; context: { $implicit: child, parentMenu: item }"></ng-container>
          </ng-container>
        </ng-container>
      </li>
      <ng-container *ngIf="item.menuPage!=null">
        <li class="subMenu_header" (click)="toggleMenu(item, userMenu,$event)">
          <ng-container *ngTemplateOutlet="renderMenuItem; context: { $implicit: item, parentMenu: item }"></ng-container>
          </li>
      </ng-container>
    </ng-container>
  </ul>
</div>

<ng-template #renderMenuItem let-item let-parentMenu="parentMenu">
  <ng-container>
    <ul class="sub-menu" *ngIf="!item.childItems.length && item.menuPage">
      <div class="iocn-link" [ngClass]="{'active': item.isExpanded}">
        <li routerLinkActive="active" [routerLink]="[item.menuPage.pageRoute]" (click)="$event.stopPropagation()">
          <a class="third_level" id="admin">
            <i class="{{ item.menuPage.pageIconUrl }}"></i>
            <span>{{ item.menuPage.pageName }}</span>
          </a>
        </li>
      </div>
    </ul>
    <ng-container *ngIf="item.childItems.length">

          <ul class="sub-menu">
            <li [ngClass]="{'showMenu': item.isExpanded}" (click)="toggleMenu(item, parentMenu.childItems,$event)">
              <div class="iocn-link" >
                <a>
                  <p class="link-name">{{item.menuName}}</p>
                 <i class="ri-arrow-down-s-line arrow"></i>
                </a>
              </div>
          <ng-container *ngIf="item.isExpanded">
            <ng-container *ngFor="let childItem of item.childItems">
              <ng-container *ngTemplateOutlet="renderMenuItem; context: { $implicit: childItem, parentMenu: item }"></ng-container>
            </ng-container>
          </ng-container>
        </li>
      </ul>
    </ng-container>
  </ng-container>
</ng-template>
